import { render, staticRenderFns } from "./SliderBanner.vue?vue&type=template&id=113f9bef&scoped=true&"
import script from "./SliderBanner.vue?vue&type=script&lang=js&"
export * from "./SliderBanner.vue?vue&type=script&lang=js&"
import style0 from "./SliderBanner.vue?vue&type=style&index=0&id=113f9bef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113f9bef",
  null
  
)

export default component.exports